import React from "react";
import { APP_ICONS } from "./appIcons";

const AppIcon = ({
  name,
  width = 24,
  height = 24,
  className = "",
  onClick,
  alt = "",
}) => {
  if (!APP_ICONS[name]) {
    return null;
  }

  return (
    <img
      src={APP_ICONS[name]}
      width={width}
      height={height}
      className={`app-icon-img ${className}`.trim()}
      onClick={onClick}
      alt={alt}
    />
  );
};

export default AppIcon;
